import React, { useEffect, useState } from 'react';
import { InputNumber } from 'antd';

const GridInputNumber = ({ value, onChange, ...props }) => {
  const [number, setNumber] = useState(value);
  const updateValue = () => onChange(number);

  useEffect(() => {
    setNumber(value);
  }, [value]);

  return (
    <InputNumber
      {...props} value={number} onChange={setNumber}
      onBlur={updateValue}
    />
  );
};

export default GridInputNumber;
